/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the WearablesApiConfiguration configuration object with a given root URL.
 */
export function provideWearablesApiConfiguration(rootUrl: string) {
  var config = new WearablesApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: WearablesApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class WearablesApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `WearablesModule.forRoot()`
 */
export interface WearablesApiConfigurationParams {
  rootUrl?: string;
}
